import { Injectable } from "@angular/core";
import { idField, ReferenceField } from "@common/references/reference-field";
import { Tariff } from "./tariffs.interfaces";
import { DefaultService } from "@common/references/default.service";
import urlJoin from "url-join";
import { environment } from "@environments/environment";
import { TariffFormComponent } from '@modules/settings/tariffs/tariff-form/tariff-form.component';

@Injectable({
  providedIn: "root",
})
export class TariffsService extends DefaultService<Tariff> {
  backendName = 'tariffs';
  formComponent = TariffFormComponent;

  title = 'MENU.TARIFFS';
  titleSingular = 'TARIFF';
  fields: ReferenceField[] = [
    idField,
    {fieldName: 'name', label: 'TARIFFS.NAME', iconClass: 'las la-tag', filter: true},
    {
      fieldName: 'utilityProvider',
      label: 'MENU.UTILITY_PROVIDERS',
      iconClass: 'las la-cube',
      fieldValue: 'name',
      filter: true
    },
    {
      fieldName: 'utilityProviderType',
      label: 'MENU.UTILITY_TYPES',
      iconClass: 'las la-cube',
      viewType: 'unitType',
      filter: true
    },
    {fieldName: 'price', label: 'TARIFFS.PRICE', iconClass: 'las la-euro-sign', filter: true},
    {
      fieldName: 'status',
      label: 'TARIFFS.STATUS',
      viewType: 'status',
      iconClass: 'las la-toggle-on',
      filter: {type: "boolean"}
    },
  ];
  hasActions = true;
  hasAdd = true;
  hasDelete = true;

  getUrl(): string {
    return urlJoin(environment.apiUrl, 'tariffs');
  }
}
